<template>
  <div class="py-4 container-fluid">
    <ToastPrime position="bottom-left" />
    <div class="card border-0 shadow-sm">
      <div
        class="card-header bg-white py-3 d-flex flex-wrap align-items-center justify-content-between gap-3 border-bottom">
        <div class="d-flex align-items-center gap-2">
          <h5 class="mb-0 fw-bold">Weekly Report</h5>
        </div>
        <div class="d-flex flex-wrap gap-2 justify-content-end align-items-center">
          <ButtonPrime
            icon="pi pi-filter"
            rounded
            size="small"
            class="ms-2"
            @click="openFilterDialog" />
          <ButtonPrime
            :icon="exporting ? 'pi pi-spin pi-spinner' : 'pi pi-file-pdf'"
            rounded
            size="small"
            class="ms-2"
            :disabled="exporting"
            @click="exportPdf"
            v-tooltip.bottom="'Export PDF'" />
        </div>
      </div>

      <div class="card-body bg-light">
        <div class="bg-white border p-3 p-md-4" ref="reportContent">
          <div class="border mt-3 small">
            <!-- HEADER ATAS -->
            <div class="table-responsive">
              <table class="table table-bordered align-middle text-center mb-0 text-secondary">
                <tbody>
                  <tr>
                    <td rowspan="2" class="align-middle" style="width: 25%">
                      <div class="d-flex flex-column align-items-center justify-content-center gap-1 text-center py-2">
                        <img
                          :src="userData.companyLogo"
                          :alt="userData.companyName"
                          style="height: 48px; max-width: 120px; object-fit: contain;"
                          class="img-fluid" />
                        <span class="small text-uppercase">{{ userData.companyName }}</span>
                      </div>
                    </td>
                    <td class="fw-normal" style="width: 50%">Weekly Report</td>
                    <td style="width: 25%">{{ todayDate }}</td>
                  </tr>
                  <tr>
                    <td class="fw-normal">Working Group : Cataloguing</td>
                    <td class="fw-normal border border-secondary-subtle">{{ userData.name }}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- I -->
            <div class="p-2 p-md-3 border-top">
              <div class="fw-bold text-uppercase text-secondary mb-2" style="font-size: 12px">
                I. Create and Revise Catalog Item
              </div>
              <div class="row g-0">
                <div class="col-12">
                  <DataTable
                    :value="table1.onLoad ? dummyRows1 : section1"
                    showGridlines
                    removable-sort
                    table-style="min-width: 100%; width: max-content;">
                    <ColumnGroup type="header">
                      <Row>
                        <Column :rowspan="2" header-class="bg-light text-nowrap text-dark align-middle">
                          <template #header>
                            <div class="text-center w-100">Status</div>
                          </template>
                        </Column>
                        <Column v-for="m in months" :key="m" :colspan="2" header-class="bg-light text-nowrap text-dark">
                          <template #header>
                            <div class="text-center w-100">{{ m }}</div>
                          </template>
                        </Column>
                        <Column :colspan="2" header-class="bg-light text-nowrap text-dark">
                          <template #header>
                            <div class="text-center w-100">Total</div>
                          </template>
                        </Column>
                      </Row>
                      <Row>
                        <template v-for="m in months" :key="'sub'+m">
                          <Column header-class="bg-light text-nowrap text-dark fw-normal">
                            <template #header>
                              <div class="text-center w-100" style="font-size: 11px;">MC</div>
                            </template>
                          </Column>
                          <Column header-class="bg-light text-nowrap text-dark fw-normal">
                            <template #header>
                              <div class="text-center w-100" style="font-size: 11px;">MR</div>
                            </template>
                          </Column>
                        </template>
                        <Column header-class="bg-light text-nowrap text-dark fw-normal">
                          <template #header>
                            <div class="text-center w-100" style="font-size: 11px;">MC</div>
                          </template>
                        </Column>
                        <Column header-class="bg-light text-nowrap text-dark fw-normal">
                          <template #header>
                            <div class="text-center w-100" style="font-size: 11px;">MR</div>
                          </template>
                        </Column>
                      </Row>
                    </ColumnGroup>
                    <Column field="label" header-class="bg-light text-nowrap text-dark">
                      <template #header>
                        <div class="text-center w-100">Status</div>
                      </template>
                      <template v-if="table1.onLoad" #body>
                        <Skeleton></Skeleton>
                      </template>
                      <template v-else #body="slotProps">
                        <div class="text-start text-nowrap text-secondary">{{ slotProps.data.label }}</div>
                      </template>
                    </Column>
                    <template v-for="i in 12" :key="'cols'+i">
                      <Column :field="'mcM' + (i - 1)">
                        <template v-if="table1.onLoad" #body>
                          <Skeleton></Skeleton>
                        </template>
                        <template v-else #body="slotProps">
                          <div class="text-center text-secondary">{{ slotProps.data['mcM' + (i - 1)] }}</div>
                        </template>
                      </Column>
                      <Column :field="'mrM' + (i - 1)">
                        <template v-if="table1.onLoad" #body>
                          <Skeleton></Skeleton>
                        </template>
                        <template v-else #body="slotProps">
                          <div class="text-center text-secondary">{{ slotProps.data['mrM' + (i - 1)] }}</div>
                        </template>
                      </Column>
                    </template>
                    <Column field="mcTotal">
                      <template v-if="table1.onLoad" #body>
                        <Skeleton></Skeleton>
                      </template>
                      <template v-else #body="slotProps">
                        <div class="text-center text-secondary fw-semibold">{{ slotProps.data.mcTotal }}</div>
                      </template>
                    </Column>
                    <Column field="mrTotal">
                      <template v-if="table1.onLoad" #body>
                        <Skeleton></Skeleton>
                      </template>
                      <template v-else #body="slotProps">
                        <div class="text-center text-secondary fw-semibold">{{ slotProps.data.mrTotal }}</div>
                      </template>
                    </Column>
                    <template #empty>
                      <div style="text-align: center; padding: 20px 0">
                        <div style="color: #888">No Data</div>
                      </div>
                    </template>
                  </DataTable>
                </div>
              </div>
            </div>

            <!-- II -->
             <div class="p-2 p-md-3">
              <div class="fw-bold text-uppercase text-secondary mb-2" style="font-size: 12px">
                II. Material Status
              </div>
              <DataTable
                :value="table4.onLoad ? dummyRows4 : materialStatus.matrix.rows"
                size="small"
                showGridlines
                table-style="min-width: 100%">
                <Column field="status" header="STATUS" header-class="bg-light text-nowrap text-dark">
                  <template v-if="table4.onLoad" #body>
                    <Skeleton></Skeleton>
                  </template>
                  <template v-else #body="slotProps">
                    <span class="fw-semibold text-dark text-xs">{{ slotProps.data && slotProps.data.label ? slotProps.data.label : '-' }}</span>
                  </template>
                </Column>
                <Column
                  v-for="type in materialStatus.matrix.types"
                  :key="type.key"
                  :header="type.label"
                  header-class="bg-light text-nowrap text-dark">
                  <template v-if="table4.onLoad" #body>
                    <Skeleton></Skeleton>
                  </template>
                  <template v-else #body="slotProps">
                    <span class="text-muted text-xs">{{ slotProps.data.cells && slotProps.data.cells[type.key] ? slotProps.data.cells[type.key] : '-' }}</span>
                  </template>
                </Column>
                <template #empty>
                  <div class="text-center py-5">
                    <img src="/no_data.png" alt="No Data" class="img-fluid opacity-75" />
                    <div class="text-secondary fw-semibold">No Data</div>
                  </div>
                </template>
              </DataTable>
            </div>

            <!-- III -->
            <div class="p-2 p-md-3">
              <div class="fw-bold text-uppercase text-secondary mb-2" style="font-size: 12px">
                III. Lead Time Cataloguing Process
              </div>
              <div class="table-responsive">
              <DataTable
                :value="table2.onLoad ? dummyRows2 : leadTimeFlat"
                showGridlines
                removable-sort
                table-style="min-width: 100%; width: max-content;">
                <ColumnGroup type="header">
                  <Row>
                    <Column :rowspan="3" header-class="bg-light text-nowrap text-dark align-middle">
                      <template #header>
                        <div class="text-center w-100">Description</div>
                      </template>
                    </Column>
                    <Column :colspan="36" header-class="bg-light text-nowrap text-dark">
                      <template #header>
                        <div class="text-center w-100">Lead Time On {{ filterDialog.form.yearDate ? filterDialog.form.yearDate.getFullYear() : currentYear }}</div>
                      </template>
                    </Column>
                    <Column :rowspan="3" header-class="bg-light text-nowrap text-dark align-middle">
                      <template #header>
                        <div class="text-center w-100">Tot Itm</div>
                      </template>
                    </Column>
                    <Column :rowspan="3" header-class="bg-light text-nowrap text-dark align-middle">
                      <template #header>
                        <div class="text-center w-100">Tot Hrs</div>
                      </template>
                    </Column>
                    <Column :rowspan="3" header-class="bg-light text-nowrap text-dark align-middle">
                      <template #header>
                        <div class="text-center w-100">Tot Dy</div>
                      </template>
                    </Column>
                  </Row>
                  <Row>
                    <Column v-for="m in months" :key="m" :colspan="3" header-class="bg-light text-nowrap text-dark fw-normal">
                      <template #header>
                        <div class="text-center w-100">{{ m }}</div>
                      </template>
                    </Column>
                  </Row>
                  <Row>
                    <template v-for="m in months" :key="'sub-' + m">
                      <Column header-class="bg-light text-nowrap text-dark fw-normal">
                        <template #header><div class="text-center w-100">Itm</div></template>
                      </Column>
                      <Column header-class="bg-light text-nowrap text-dark fw-normal">
                        <template #header><div class="text-center w-100">Hrs</div></template>
                      </Column>
                      <Column header-class="bg-light text-nowrap text-dark fw-normal">
                        <template #header><div class="text-center w-100">Dy</div></template>
                      </Column>
                    </template>
                  </Row>
                </ColumnGroup>
                <Column field="label" header-class="bg-light text-nowrap text-dark">
                  <template #header>
                    <div class="text-center w-100">Description</div>
                  </template>
                  <template v-if="table2.onLoad" #body>
                    <Skeleton></Skeleton>
                  </template>
                  <template v-else #body="slotProps">
                    <div class="text-start text-nowrap text-secondary">{{ slotProps.data.label }}</div>
                  </template>
                </Column>
                <template v-for="i in 12" :key="i">
                  <Column :field="'m' + (i - 1) + 'Item'">
                    <template v-if="table2.onLoad" #body>
                      <Skeleton></Skeleton>
                    </template>
                    <template v-else #body="slotProps">
                      <div class="text-center text-secondary">{{ slotProps.data['m' + (i - 1) + 'Item'] }}</div>
                    </template>
                  </Column>
                  <Column :field="'m' + (i - 1) + 'Hours'">
                    <template v-if="table2.onLoad" #body>
                      <Skeleton></Skeleton>
                    </template>
                    <template v-else #body="slotProps">
                      <div class="text-center text-secondary">{{ slotProps.data['m' + (i - 1) + 'Hours'] }}</div>
                    </template>
                  </Column>
                  <Column :field="'m' + (i - 1) + 'Days'">
                    <template v-if="table2.onLoad" #body>
                      <Skeleton></Skeleton>
                    </template>
                    <template v-else #body="slotProps">
                      <div class="text-center text-secondary">{{ slotProps.data['m' + (i - 1) + 'Days'] }}</div>
                    </template>
                  </Column>
                </template>
                <Column field="totalItem" header-class="bg-light text-nowrap text-dark">
                  <template #header>
                    <div class="text-center w-100">Tot Itm</div>
                  </template>
                  <template v-if="table2.onLoad" #body>
                    <Skeleton></Skeleton>
                  </template>
                  <template v-else #body="slotProps">
                    <div class="text-center text-secondary">{{ slotProps.data.totalItem }}</div>
                  </template>
                </Column>
                <Column field="totalHours" header-class="bg-light text-nowrap text-dark">
                  <template #header>
                    <div class="text-center w-100">Tot Hrs</div>
                  </template>
                  <template v-if="table2.onLoad" #body>
                    <Skeleton></Skeleton>
                  </template>
                  <template v-else #body="slotProps">
                    <div class="text-center text-secondary">{{ slotProps.data.totalHours }}</div>
                  </template>
                </Column>
                <Column field="totalDays" header-class="bg-light text-nowrap text-dark">
                  <template #header>
                    <div class="text-center w-100">Tot Dy</div>
                  </template>
                  <template v-if="table2.onLoad" #body>
                    <Skeleton></Skeleton>
                  </template>
                  <template v-else #body="slotProps">
                    <div class="text-center text-secondary">{{ slotProps.data.totalDays }}</div>
                  </template>
                </Column>
                <template #empty>
                  <div style="text-align: center; padding: 20px 0">
                    <div style="color: #888">No Data</div>
                  </div>
                </template>
              </DataTable>
              </div>

              <!-- CHART seperti gambar -->
              <div class="mt-3 px-0 px-md-2 pb-2 bg-white">
                <div class="d-flex justify-content-center align-items-center gap-3 mb-2 text-secondary">
                  <span class="d-flex align-items-center gap-1">
                    <span class="d-inline-block border border-primary bg-primary bg-opacity-10" style="width: 30px; height: 13px"></span>
                    <span>New Material</span>
                  </span>
                  <span class="d-flex align-items-center gap-1">
                    <span class="d-inline-block border border-warning bg-warning bg-opacity-10" style="width: 30px; height: 13px"></span>
                    <span>Material Revision</span>
                  </span>
                </div>

                <div class="d-flex">
                  <div class="d-flex flex-column justify-content-between text-muted text-end pe-1" style="width: 26px; height: 300px; font-size: 12px; line-height: 1">
                    <span>12</span><span>10</span><span>8</span><span>6</span><span>4</span><span>2</span><span>0</span>
                  </div>
                  <div class="flex-grow-1">
                    <div class="position-relative border-start border-bottom" style="height: 300px; border-color: #dee2e6 !important">
                      <div v-for="g in 6" :key="g" class="position-absolute w-100 border-top" :style="{ top: (g * 50) + 'px', borderColor: '#e9ecef !important', opacity: '1' }"></div>
                      <div class="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-stretch">
                        <div
                          v-for="(m, idx) in shortMonths"
                          :key="m"
                          class="flex-grow-1 d-flex align-items-end justify-content-center border-start"
                          style="border-color: #e9ecef !important">
                          <div class="d-flex align-items-end gap-1 h-100 pb-0">
                            <div
                              class="border border-primary bg-primary bg-opacity-10 mt-auto"
                              :style="{ height: barHeight(chartNew[idx]), width: '18px' }"></div>
                            <div
                              class="border border-warning bg-warning bg-opacity-10 mt-auto"
                              :style="{ height: barHeight(chartRev[idx]), width: '18px' }"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="d-flex text-muted pt-1" style="font-size: 12px">
                      <span v-for="m in shortMonths" :key="m" class="flex-grow-1 text-center text-truncate">{{ m }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- IV -->
             <div class="p-2 p-md-3">
              <div class="fw-bold text-uppercase text-secondary mb-2" style="font-size: 12px">
                IV. MRP Composition
              </div>
              <DataTable
                :value="table3.onLoad ? dummyRows3 : mrpComposition.matrix.rows"
                size="small"
                showGridlines
                table-style="min-width: 100%">
                <Column field="description" header="MRP ELEMENT" header-class="bg-light text-nowrap text-dark">
                  <template v-if="table3.onLoad" #body>
                    <Skeleton></Skeleton>
                  </template>
                  <template v-else #body="slotProps">
                    <span class="fw-semibold text-dark text-xs">{{ slotProps.data && slotProps.data.label ? slotProps.data.label : '-' }}</span>
                  </template>
                </Column>
                <Column
                  v-for="type in mrpComposition.matrix.types"
                  :key="type.key"
                  :header="type.label"
                  header-class="bg-light text-nowrap text-dark">
                  <template v-if="table3.onLoad" #body>
                    <Skeleton></Skeleton>
                  </template>
                  <template v-else #body="slotProps">
                    <span class="text-muted text-xs">{{ slotProps.data.cells && slotProps.data.cells[type.key] ? slotProps.data.cells[type.key] : '-' }}</span>
                  </template>
                </Column>
                <template #empty>
                  <div class="text-center py-5">
                    <img src="/no_data.png" alt="No Data" class="img-fluid opacity-75" />
                    <div class="text-secondary fw-semibold">No Data</div>
                  </div>
                </template>
              </DataTable>
            </div>
          </div>
          <div class="d-flex justify-content-between align-items-center mt-4 small text-muted">
          </div>
        </div>
      </div>
    </div>

    <!-- Dialog Filter -->
    <DialogPrime v-model:visible="filterDialog.visible" modal :draggable="false" style="width: 25rem; margin: 10px;">
      <template #header>
        <div class="d-flex align-items-center gap-3">
          <h5 class="mb-0 fw-bold text-dark">Filter</h5>
        </div>
      </template>
      <div class="row g-4">
        <div class="col-12">
          <div class="row g-3">
            <div class="col-12">
              <label for="filter-year" class="form-label fw-semibold">Year</label>
              <Calendar
                id="filter-year"
                v-model="filterDialog.form.yearDate"
                view="year"
                date-format="yy"
                placeholder="Select Year"
                :show-icon="true"
                class="w-100" />
            </div>
          </div>
        </div>
      </div>
      <template #footer>
        <div class="d-flex justify-content-end gap-2 pt-3 border-top w-100 mt-2 px-1">
          <ButtonPrime type="button" label="Reset" severity="danger" raised size="small" class="px-4 border-0"
            @click="resetFilter()" />
          <ButtonPrime type="button" severity="contrast" raised size="small" label="Apply Filter" class="px-4"
            @click="applyFilter()" />
        </div>
      </template>
    </DialogPrime>
  </div>
</template>

<script>
import ColumnGroup from 'primevue/columngroup';
import Row from 'primevue/row';
import api from "@/helpers/api";
import dashboardService from "@/services/dashboards/dashboardService";
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

export default {
  components: {
    ColumnGroup,
    Row,
  },
  computed: {
    userData() {
      try {
        const auth = JSON.parse(localStorage.getItem('userAuth') || '{}');
        const user = auth?.user || {};
        const code = (user.company_code || '').toString().toLowerCase();
        const companyNameMap = { 'mind-id': 'MIND ID', inalum: 'Inalum', antam: 'Antam', timah: 'Timah' };
        const companyLogoMap = {
          'mind-id': `${process.env.BASE_URL || '/'}mind-id.png`,
          inalum: `${process.env.BASE_URL || '/'}inalum.png`,
          antam: `${process.env.BASE_URL || '/'}antam.png`,
          timah: `${process.env.BASE_URL || '/'}timah.png`,
        };
        return {
          name: user.name || '',
          companyCode: code,
          companyName: companyNameMap[code] || 'MIND ID',
          companyLogo: companyLogoMap[code] || `${process.env.BASE_URL || '/'}mind-id.png`,
        };
      } catch {
        return { name: '', companyCode: '', companyName: 'MIND ID', companyLogo: `${process.env.BASE_URL || '/'}mind-id.png` };
      }
    },
    todayDate() {
      const d = new Date();
      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      return `${months[d.getMonth()]} ${d.getDate()}, ${d.getFullYear()}`;
    },
  },
  data() {
    return {
      months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      shortMonths: ['Jan', 'Feb', 'March', 'April', 'May', 'June', 'July', 'August', 'Sep', 'Oct', 'Nov', 'Dec'],
      filterDialog: {
        visible: false,
        form: { yearDate: new Date() },
      },
      table1: { onLoad: true },
      table2: { onLoad: true },
      table3: { onLoad: true },
      table4: { onLoad: true },
      dummyRows1: Array.from({ length: 6 }, () => ({})),
      dummyRows2: Array.from({ length: 2 }, () => ({})),
      dummyRows3: Array.from({ length: 5 }, () => ({})),
      dummyRows4: Array.from({ length: 5 }, () => ({})),
      section1: [],
      leadTimeFlat: [
        { label: 'Create New Material' },
        { label: 'Material Revision' },
      ],
      chartNew: Array(12).fill(0),
      chartRev: Array(12).fill(0),
      mrpComposition: {
        matrix: { types: [], rows: [] },
      },
      materialStatus: {
        matrix: { types: [], rows: [] },
      },
      materialStatusOrder: ["Z1", "Z2", "Z3", "Z4", "Z5", "Z6", "Z7", "Z8"],
      exporting: false,
    };
  },
  mounted() {
    this.get();
  },
  methods: {
    openFilterDialog() {
      this.filterDialog.visible = true;
    },
    resetFilter() {
      this.filterDialog.form = { yearDate: new Date() };
      this.filterDialog.visible = false;
      this.get();
    },
    applyFilter() {
      this.filterDialog.visible = false;
      this.get();
    },
    async get() {
      this.table1.onLoad = true;
      this.table2.onLoad = true;
      this.table3.onLoad = true;
      this.table4.onLoad = true;
      try {
        const year = this.filterDialog.form.yearDate ? this.filterDialog.form.yearDate.getFullYear() : new Date().getFullYear();
        const response = await api(this, dashboardService.get({ year }), false);
        const data = response.data || {};

        this.parseSection1(data.material_creation_revision || {});
        this.parseSection2(data.lead_time_mcr || {});
        this.parseSection3(data.mrp_composition || {});
        this.parseSection4(data.material_status || {});
      } catch (error) {
        console.error('Failed to load weekly report:', error);
      } finally {
        this.table1.onLoad = false;
        this.table2.onLoad = false;
        this.table3.onLoad = false;
        this.table4.onLoad = false;
      }
    },

    /**
     * Section I: Create and Revise Catalog Item
     * Satu tabel: Status | Jan (MC|MR) | Feb (MC|MR) | ... | Dec (MC|MR) | Total (MC|MR)
     */
    parseSection1(mcr) {
      const statusMap = {
        processing: 'Processing',
        rejected: 'Rejected',
        stored_in_sap: 'Stored In SAP',
        closed: 'Closed',
        canceled: 'Canceled',
        duplicated: 'Duplicated',
      };

      const rows = [];

      for (const [statusKey, statusLabel] of Object.entries(statusMap)) {
        const row = { label: statusLabel };
        let totalMc = 0;
        let totalMr = 0;

        for (let i = 1; i <= 12; i++) {
          const statusData = (mcr[i.toString()] || {})[statusKey] || {};
          const mc = statusData.material_creation || 0;
          const mr = statusData.material_revision || 0;
          row['mcM' + (i - 1)] = mc;
          row['mrM' + (i - 1)] = mr;
          totalMc += mc;
          totalMr += mr;
        }

        row.mcTotal = totalMc;
        row.mrTotal = totalMr;
        rows.push(row);
      }

      this.section1 = rows;
    },

    /**
     * Section II: Lead Time Cataloguing Process
     * Ambil day_per_item dari material_creation & material_revision per bulan.
     */
    parseSection2(ltm) {
      const newMatRow = { label: 'Create New Material', totalItem: 0, totalHours: 0, totalDays: 0 };
      const revRow = { label: 'Material Revision', totalItem: 0, totalHours: 0, totalDays: 0 };
      const chartNew = [];
      const chartRev = [];

      for (let i = 1; i <= 12; i++) {
        const monthData = ltm[i.toString()] || {};
        const creation = monthData.material_creation || {};
        const revision = monthData.material_revision || {};
        const creationDay = creation.day_per_item || 0;
        const revisionDay = revision.day_per_item || 0;

        const cItems = Number(creation.total_item) || 0;
        const rItems = Number(revision.total_item) || 0;
        const cHours = Number(creation.total_duration_hours) || 0;
        const rHours = Number(revision.total_duration_hours) || 0;

        const idx = i - 1;
        newMatRow['m' + idx + 'Item'] = cItems;
        newMatRow['m' + idx + 'Hours'] = parseFloat(cHours.toFixed(2));
        newMatRow['m' + idx + 'Days'] = parseFloat((cHours / 8).toFixed(2));
        newMatRow.totalItem += cItems;
        newMatRow.totalHours += cHours;

        revRow['m' + idx + 'Item'] = rItems;
        revRow['m' + idx + 'Hours'] = parseFloat(rHours.toFixed(2));
        revRow['m' + idx + 'Days'] = parseFloat((rHours / 8).toFixed(2));
        revRow.totalItem += rItems;
        revRow.totalHours += rHours;

        chartNew.push(creationDay);
        chartRev.push(revisionDay);
      }

      newMatRow.totalHours = parseFloat(newMatRow.totalHours.toFixed(2));
      newMatRow.totalDays = parseFloat((newMatRow.totalHours / 8).toFixed(2));
      revRow.totalHours = parseFloat(revRow.totalHours.toFixed(2));
      revRow.totalDays = parseFloat((revRow.totalHours / 8).toFixed(2));

      this.leadTimeFlat = [newMatRow, revRow];
      this.chartNew = chartNew;
      this.chartRev = chartRev;
    },

    parseSection3(mrpByMonth) {
      const byMonth = mrpByMonth && typeof mrpByMonth === "object" ? mrpByMonth : {};
      const cellTotals = {};
      const descriptionTotals = {};
      const typeTotals = {};

      Object.values(byMonth).forEach((monthRows) => {
        if (!Array.isArray(monthRows)) return;
        monthRows.forEach((entry) => {
          if (!entry) return;
          const description = entry.description || "-";
          const materialType = entry.material_type || "-";
          const count = Number(entry.count) || 0;
          if (count <= 0) return;

          const cellKey = `${description}|${materialType}`;
          cellTotals[cellKey] = (cellTotals[cellKey] || 0) + count;
          descriptionTotals[description] = (descriptionTotals[description] || 0) + count;
          typeTotals[materialType] = (typeTotals[materialType] || 0) + count;
        });
      });

      const descriptionKeys = Object.keys(descriptionTotals).sort((a, b) => descriptionTotals[b] - descriptionTotals[a]);
      const typeKeys = Object.keys(typeTotals).sort((a, b) => typeTotals[b] - typeTotals[a]);

      this.mrpComposition = {
        matrix: {
          types: typeKeys.map((type) => ({ key: type, label: type })),
          rows: descriptionKeys.map((description) => {
            const cells = {};
            typeKeys.forEach((type) => {
              cells[type] = cellTotals[`${description}|${type}`] || 0;
            });
            return { label: description, cells };
          }),
        },
      };
    },

    parseSection4(statusByMonth) {
      const byMonth = statusByMonth && typeof statusByMonth === "object" ? statusByMonth : {};
      const cellTotals = {};
      const statusTotals = {};
      const typeTotals = {};

      Object.values(byMonth).forEach((monthData) => {
        if (!monthData || typeof monthData !== "object") return;
        ["client", "plant"].forEach((level) => {
          if (!Array.isArray(monthData[level])) return;
          monthData[level].forEach((entry) => {
            if (!entry) return;
            const status = entry.status || entry.block_reason || entry.plant_sp || "-";
            const materialType = entry.material_type || "-";
            const count = Number(entry.count) || 0;
            if (count <= 0) return;

            const cellKey = `${status}|${materialType}`;
            cellTotals[cellKey] = (cellTotals[cellKey] || 0) + count;
            statusTotals[status] = (statusTotals[status] || 0) + count;
            typeTotals[materialType] = (typeTotals[materialType] || 0) + count;
          });
        });
      });

      const statusKeys = Object.keys(statusTotals).sort((a, b) => {
        const idxA = this.materialStatusOrder.indexOf(a);
        const idxB = this.materialStatusOrder.indexOf(b);
        if (idxA !== -1 && idxB !== -1) return idxA - idxB;
        if (idxA !== -1) return -1;
        if (idxB !== -1) return 1;
        return a.localeCompare(b);
      });
      const typeKeys = Object.keys(typeTotals).sort((a, b) => typeTotals[b] - typeTotals[a]);

      this.materialStatus = {
        matrix: {
          types: typeKeys.map((type) => ({ key: type, label: type })),
          rows: statusKeys.map((status) => {
            const cells = {};
            typeKeys.forEach((type) => {
              cells[type] = cellTotals[`${status}|${type}`] || 0;
            });
            return { label: status, cells };
          }),
        },
      };
    },

    barHeight(val) {
      if (!val) return '2px';
      const max = Math.max(...this.chartNew, ...this.chartRev, 1);
      return Math.round((val / max) * 100) + '%';
    },    async _captureToPdf(el, filename) {
      // Clone into hidden container at full width, strip all constraints
      const cloneContainer = document.createElement('div');
      cloneContainer.style.cssText = 'position:fixed;top:0;left:0;z-index:-9999;width:100vw;overflow:visible;background:#fff;';
      document.body.appendChild(cloneContainer);

      const clone = el.cloneNode(true);
      clone.style.cssText = 'width:100vw;overflow:visible;';
      cloneContainer.appendChild(clone);

      // Strip all scroll/overflow constraints from clone
      const removeProps = ['overflow','overflowX','overflowY','maxHeight','maxWidth'];
      clone.querySelectorAll('*').forEach(node => {
        removeProps.forEach(p => node.style.removeProperty(p));
        if (node.classList.contains('p-datatable-wrapper') || node.classList.contains('table-responsive')) {
          node.style.overflow = 'visible';
          node.style.maxWidth = 'none';
        }
        if (node.classList.contains('p-datatable-table') || node.classList.contains('table')) {
          node.style.width = 'auto';
          node.style.minWidth = '100%';
        }
      });

      await new Promise(r => setTimeout(r, 200));

      const canvas = await html2canvas(clone, {
        scale: 3,
        useCORS: true,
        logging: false,
        backgroundColor: '#ffffff',
        width: clone.scrollWidth,
        height: clone.scrollHeight,
        windowWidth: clone.scrollWidth,
        windowHeight: clone.scrollHeight,
      });

      document.body.removeChild(cloneContainer);

      // A3 landscape: 420 x 297 mm
      const imgWidth = 420;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      const pdf = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a3' });
      const pageH = pdf.internal.pageSize.getHeight();
      const pageW = pdf.internal.pageSize.getWidth();
      let heightLeft = imgHeight;
      let position = 0;
      const imgData = canvas.toDataURL('image/png');
      pdf.addImage(imgData, 'PNG', 0, position, pageW, imgHeight);
      heightLeft -= pageH;
      while (heightLeft > 0) {
        position -= pageH;
        pdf.addPage();
        pdf.addImage(imgData, 'PNG', 0, position, pageW, imgHeight);
        heightLeft -= pageH;
      }
      pdf.save(filename);
    },

    async exportPdf() {
      if (!this.section1 && !this.materialStatus.matrix.rows.length && !this.mrpComposition.matrix.rows.length) return;
      this.exporting = true;
      await this.$nextTick();
      await new Promise(r => setTimeout(r, 300));
      try {
        const el = this.$refs.reportContent;
        if (!el) return;
        const year = this.filterDialog.form.yearDate ? this.filterDialog.form.yearDate.getFullYear() : new Date().getFullYear();
        await this._captureToPdf(el, 'Weekly-Report-Cataloguing-' + year + '.pdf');
      } catch (err) {
        console.error('Export PDF failed:', err);
      } finally {
        this.exporting = false;
      }
    },
  },
};
</script>